/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER, NG_TABLE_DEFAULT_PARAMS) {
        var base = "admin/buscador";
        var params = {
            base: base,
            baseUrl: "/" + base,
            templateUrlBase: "app/admin/edicion/edicion.total/edicion.total",
            controller: 'EdicionAdminController',
            controllerForm: 'EdicionFormAdminController',
            translateBase: "admin.edicion.total"
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_INVESTIGADOR'],
                pageTitle: 'ediciontotal.title'
            }
        });

        // Listar
        angular.merge(state.list, {
            url: '/listar/:page',
            params: {
                page: '1',
                filter: {sortProperty: 'titulo', sortDirection: 'ASC', size: NG_TABLE_DEFAULT_PARAMS.size},
                idResponsable: null,
                nombreResponsable: null,
                rolResponsable: null,
                idLugar: null,
                nombreLugar: null

            }, resolve: {
                /* @ngInject */
                ediciones: function () {
                    return {};
                },
                /* @ngInject */
                tipologias: function (Tipologia) {
                    return Tipologia.findAll({sortProperty: 'nombre'}).$promise.then(function (data) {
                        return data.content;
                    });
                },
                /* @ngInject */
                subgeneros: function (Subgenero) {
                    return Subgenero.findAll({sortProperty: 'nombre'}).$promise.then(function (data) {
                        return data.content;
                    });
                },
                /* @ngInject */
                modalidades: function (EnumService) {
                    return EnumService.get("modalidaddiscurso");
                },
                /* @ngInject */
                tamanos: function (EnumService) {
                    return EnumService.get("tamano");
                },
                /* @ngInject */
                stateParams: function ($stateParams) {
                    return $stateParams;
                }
            }
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list);
    }
})();
